// Player & Table State Animations
import gsap from 'gsap';
import * as PIXI from 'pixi.js';

export function animatePlayerIdle(marker: PIXI.Graphics) {
  gsap.to(marker, {
    alpha: 0.8,
    duration: 1.2,
    yoyo: true,
    repeat: -1,
    ease: 'sine.inOut',
  });
}

export function animateActionRequired(marker: PIXI.Graphics) {
  gsap.to(marker, {
    alpha: 1,
    duration: 0.5,
    yoyo: true,
    repeat: -1,
    ease: 'power1.inOut',
  });
}

export function animateTimerCritical(marker: PIXI.Graphics) {
  gsap.to(marker, {
    alpha: 1,
    duration: 0.2,
    yoyo: true,
    repeat: -1,
    ease: 'power1.inOut',
    color: 0xFF3333,
  });
}

export function animateWinningPlayer(marker: PIXI.Graphics) {
  gsap.to(marker, {
    scale: 1.2,
    duration: 0.6,
    yoyo: true,
    repeat: 2,
    ease: 'back.out(2)',
    onComplete: () => {
      // Add radial wave/particle effect here
    }
  });
}

export function animateEliminatedPlayer(marker: PIXI.Graphics) {
  gsap.to(marker, {
    alpha: 0,
    duration: 0.7,
    ease: 'power1.in',
    onComplete: () => {
      // Add bust particle effect here
    }
  });
}
